// Standardized filter type enum for entity viewer filters
export const FilterType = Object.freeze({
    TEXT: 'text',
    NUMBER: 'number',
    SELECT: 'select',
    DATE_RANGE: 'dateRange',
});
